import React from 'react'
import BaseImgBtn from './BaseImgBtn'

import img from 'assets/img/ic-approve.png'

const ApproveBtn = (props: any) => {
  return <BaseImgBtn img={img} onClick={props.onClick} />
}

export default ApproveBtn
